import { render, staticRenderFns } from "./survey-view.vue?vue&type=template&id=a8c248c6&"
import script from "./survey-view.vue?vue&type=script&lang=js&"
export * from "./survey-view.vue?vue&type=script&lang=js&"
import style0 from "./survey-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports